// extracted by mini-css-extract-plugin
export default {"ZonesAndBedsContainer":"ZonesBedManagement_ZonesAndBedsContainer__-p90a"};